// extracted by mini-css-extract-plugin
export default {"batch_list_orders":"Order_batch_list_orders__sDWBI","table_container":"Order_table_container__R-VG+"};